import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { uniqBy } from 'lodash';

import { PROPERTY_TYPES } from '../../constants';
import { captureViewportInfo, fetchFavoriteBuildings, fetchFavoriteSites, activateModal } from '../../store/actions';
import { fetchAreas } from '../../store/actions/areas';

import withSize from '../WithSize/WithSize';
import DraggableList from '../List/DraggableList';
import StatesListItem from '../List/Areas/StatesListItem';
import RegionsListItem from '../List/Areas/RegionsListItem';
import CountiesListItem from '../List/Areas/CountiesListItem';
import CommunitiesListItem from '../List/Areas/CommunitiesListItem';
import RemoveAllAction from './RemoveAllAction';
import { FoldersMap } from './FoldersMap/FoldersMap';
// import MapWrapper from '../Map/MapWrapper';
import FoldersModal from './FoldersModal';
import FavoritesHeader from './FavoritesHeader';
import ExportModal from './ExportModal/ExportModal';
import ShareModal from '../Modal/ShareModal/ShareModal';
import FolderInstructionsModal from './FolderInstructionsModal/FolderInstructionsModal';

import './FavoritesWrapper.css';
import ViewerPrimaryColorUserStyle from '../UserCustomization/ViewerPrimaryColorUserStyle';

export class FavoritesWrapperComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalProperties: [],
      modalPropertyType: null,
      modalAction: 'remove',
    };

    this.relayShowBuildingDetail = this.relayShowBuildingDetail.bind(this);
    this.relayShowSiteDetail = this.relayShowSiteDetail.bind(this);
    this.relayShowAreaDetail = this.relayShowAreaDetail.bind(this);
    this.relayRemoveFromFolder = this.relayRemoveFromFolder.bind(this);
  }

  componentDidMount() {
    const {
      getBuildings,
      getSites,
      getStates,
      getRegions,
      getCounties,
      getCommunities,
      needsBuildings,
      needBuildingIds,
      needsSites,
      needSiteIds,
      needsStates,
      needsRegions,
      needsCounties,
      needsCommunities,
      organizationId,
    } = this.props;
    // only fetch if there are saved buildings or sites
    if (needsBuildings) {
      getBuildings(organizationId, needBuildingIds);
    }

    if (needsSites) {
      getSites(organizationId, needSiteIds);
    }

    if (needsStates) {
      getStates(organizationId);
    }

    if (needsRegions) {
      getRegions(organizationId);
    }

    if (needsCounties) {
      getCounties(organizationId);
    }

    if (needsCommunities) {
      getCommunities(organizationId);
    }
  }

  relayRemoveFromFolder({ action, properties, propertyType }) {
    this.setState(prevState => ({
      ...prevState,
      modalAction: action,
      modalProperties: properties,
      modalPropertyType: propertyType,
    }));
  }

  relayShowBuildingDetail(buildingId) {
    this.props.routeTo(`/buildings/${buildingId}${window.location.search}`);
  }

  relayShowSiteDetail(siteId) {
    this.props.routeTo(`/sites/${siteId}${window.location.search}`);
  }

  relayShowAreaDetail(layer, area) {
    this.props.routeTo(`/areas/${layer}/${area._id}${window.location.search}`);
  }

  render() {
    const {
      buildings,
      sites,
      states,
      regions,
      counties,
      communities,
      activeFolder,
      folders = [],
      openExportModal,
      showShareModal,
      organizationId,
      authenticated,
      displayName,
      showFolderInstructionsModal,
      savedProperties,
      onViewportChanged,
      // defaultZoom,
      markers,
    } = this.props;
    const [folder = {}] = folders.filter(f => f.id === activeFolder);
    const {
      buildings: buildingIds = [],
      sites: siteIds = [],
      states: stateIds = [],
      regions: regionIds = [],
      counties: countyIds = [],
      communities: communityIds = [],
    } = folder;
    const sortByName = (a, b) => (a.name > b.name ? 1 : -1);
    let folderBuildings = buildings.filter(b => buildingIds.indexOf(b._id) > -1);
    let folderSites = sites.filter(s => siteIds.indexOf(s._id) > -1);
    let folderStates = states
      .filter(s => stateIds.indexOf(s._id.toString()) > -1)
      .sort(sortByName);
    let folderRegions = regions
      .filter(r => regionIds.indexOf(r._id.toString()) > -1)
      .sort(sortByName);
    let folderCounties = counties
      .filter(c => countyIds.indexOf(c._id.toString()) > -1)
      .sort(sortByName);
    let folderCommunities = communities
      .filter(c => communityIds.indexOf(c._id.toString()) > -1)
      .sort(sortByName);
    const folderAreasCount = stateIds.length +
      regionIds.length +
      countyIds.length +
      communityIds.length;
    const share = {
      buildings: buildingIds.length > 0 ? new Map([['_id', buildingIds]]) : new Map(),
      sites: siteIds.length > 0 ? new Map([['_id', siteIds]]) : new Map(),
    };

    folderBuildings = uniqBy(folderBuildings, '_id');
    folderSites = uniqBy(folderSites, '_id');
    folderStates = uniqBy(folderStates, '_id');
    folderRegions = uniqBy(folderRegions, '_id');
    folderCounties = uniqBy(folderCounties, '_id');
    folderCommunities = uniqBy(folderCommunities, '_id');

    return (
      <div className="favorites">
        {this.props.activeModal === 'folder-instructions-modal' && (
          <FolderInstructionsModal />
        )}
        {this.props.activeModal === 'share-map' && (
          <ShareModal favorites={share} />
        )}
        {this.props.activeModal === 'folders' && (
          <FoldersModal
            items={this.state.modalProperties}
            itemType={this.state.modalPropertyType}
            action={this.state.modalAction}
          />
        )}
        {this.props.activeModal === 'export-modal' && (
          <ExportModal
            buildings={folderBuildings}
            sites={folderSites}
            states={folderStates}
            regions={folderRegions}
            counties={folderCounties}
            communities={folderCommunities}
            organizationId={organizationId}
          />
        )}
        <FavoritesHeader
          onExport={openExportModal}
          showShareModal={showShareModal}
          showFolderInstructionsModal={showFolderInstructionsModal}
          authenticated={authenticated}
          displayName={displayName}
        />
        <div className="favorites__body">
          {/* <a
            href="https://s3.amazonaws.com/lois-videos/lois-my-favorites.mp4"
            className="favorites-video-link btn--link"
          >
            My Favorites Training Video
          </a> */}
          <div className="favorites-list__body">
            <div className="favorites-list-wrapper">
              <div className="favorites-list">
                <div className="favorites-list__header">
                  <div className="favorites-list__title">
                    <span>Buildings</span>
                    <ViewerPrimaryColorUserStyle domStyle="color">
                      <span style={{ hidden: folderBuildings.length === 0 }}>
                        {folderBuildings.length}
                      </span>
                    </ViewerPrimaryColorUserStyle>
                  </div>
                  <div className="favorites-list__actions">
                    {folderBuildings.length > 0 && (
                      <RemoveAllAction
                        handleClick={this.relayRemoveFromFolder}
                        action={'remove-all-favorites'}
                        properties={folderBuildings}
                        propertyType={PROPERTY_TYPES.BUILDINGS}
                      />
                    )}
                  </div>
                </div>
                <DraggableList
                  properties={folderBuildings}
                  type={PROPERTY_TYPES.BUILDINGS}
                  handleModalOpen={this.relayRemoveFromFolder}
                  activeFolder={activeFolder}
                  markers={markers}
                />
              </div>
              <div className="favorites-list">
                <div className="favorites-list__header">
                  <div className="favorites-list__title">
                    <span>Sites</span>
                    <ViewerPrimaryColorUserStyle domStyle="color">
                      <span style={{ hidden: folderSites.length === 0 }}>
                        {folderSites.length}
                      </span>
                    </ViewerPrimaryColorUserStyle>
                  </div>
                  <div className="favorites-list__actions">
                    {folderSites.length > 0 && (
                      <RemoveAllAction
                        handleClick={this.relayRemoveFromFolder}
                        action={'remove-all-favorites'}
                        properties={folderSites}
                        propertyType={PROPERTY_TYPES.SITES}
                      />
                    )}
                  </div>
                </div>
                <DraggableList
                  properties={folderSites}
                  type={PROPERTY_TYPES.SITES}
                  handleModalOpen={this.relayRemoveFromFolder}
                  activeFolder={activeFolder}
                  markers={markers}
                />
              </div>
              <div className="favorites-list">
                <div className="favorites-list__header">
                  <div className="favorites-list__title">
                    <span>Areas</span>
                    <ViewerPrimaryColorUserStyle domStyle="color">
                      <span style={{ hidden: folderAreasCount === 0 }}>
                        {folderAreasCount}
                      </span>
                    </ViewerPrimaryColorUserStyle>
                  </div>
                  <div className="favorites-list__actions" />
                </div>
                <ul className="favorites-list__items list-wrapper" data-bd-empty="No saved areas">
                  {stateIds.length > 0 && (
                  <li className="favorites-list-item--header">
                    <ViewerPrimaryColorUserStyle domStyle="color">
                      <span>States</span>
                    </ViewerPrimaryColorUserStyle>
                    <div className="favorites-list__actions">
                      <RemoveAllAction
                        handleClick={this.relayRemoveFromFolder}
                        action={'remove-all-favorites'}
                        properties={folderStates}
                        propertyType="states"
                      />
                    </div>
                  </li>
                )}
                  {folderStates.map(state => (
                    <StatesListItem
                      key={state.id}
                      favoritesType="states"
                      handleClick={this.relayShowAreaDetail}
                      state={state}
                    />
                ))}
                  {regionIds.length > 0 && (
                  <li className="favorites-list-item--header">
                    <ViewerPrimaryColorUserStyle domStyle="color">
                      <span>Regions</span>
                    </ViewerPrimaryColorUserStyle>
                    <div className="favorites-list__actions">
                      <RemoveAllAction
                        handleClick={this.relayRemoveFromFolder}
                        action={'remove-all-favorites'}
                        properties={folderRegions}
                        propertyType="regions"
                      />
                    </div>
                  </li>
                )}
                  {folderRegions.map(region => (
                    <RegionsListItem
                      key={region.id}
                      favoritesType="regions"
                      handleClick={this.relayShowAreaDetail}
                      region={region}
                    />
                ))}
                  {countyIds.length > 0 && (
                  <li className="favorites-list-item--header">
                    <ViewerPrimaryColorUserStyle domStyle="color">
                      <span>Counties</span>
                    </ViewerPrimaryColorUserStyle>
                    <div className="favorites-list__actions">
                      <RemoveAllAction
                        handleClick={this.relayRemoveFromFolder}
                        action={'remove-all-favorites'}
                        properties={folderCounties}
                        propertyType="counties"
                      />
                    </div>
                  </li>
                )}
                  {folderCounties.map(county => (
                    <CountiesListItem
                      key={county.id}
                      favoritesType="counties"
                      handleClick={this.relayShowAreaDetail}
                      county={county}
                    />
                ))}
                  {communityIds.length > 0 && (
                  <li className="favorites-list-item--header">
                    <ViewerPrimaryColorUserStyle domStyle="color">
                      <span>Communities</span>
                    </ViewerPrimaryColorUserStyle>
                    <div className="favorites-list__actions">
                      <RemoveAllAction
                        handleClick={this.relayRemoveFromFolder}
                        action={'remove-all-favorites'}
                        properties={folderCommunities}
                        propertyType="communities"
                      />
                    </div>
                  </li>
                )}
                  {folderCommunities.map(community => (
                    <CommunitiesListItem
                      key={community.id}
                      favoritesType="communities"
                      handleClick={this.relayShowAreaDetail}
                      community={community}
                    />
                ))}
                </ul>
              </div>
            </div>
            {(savedProperties && savedProperties.length > 0) && (
              <FoldersMap
                handleModalOpen={this.relayRemoveFromFolder}
                onViewportChanged={onViewportChanged}
                properties={savedProperties}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

FavoritesWrapperComponent.propTypes = {
  activeModal: PropTypes.string,
  activeFolder: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  folders: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
  buildings: PropTypes.arrayOf(PropTypes.object),
  sites: PropTypes.arrayOf(PropTypes.object),
  states: PropTypes.arrayOf(PropTypes.object),
  regions: PropTypes.arrayOf(PropTypes.object),
  counties: PropTypes.arrayOf(PropTypes.object),
  communities: PropTypes.arrayOf(PropTypes.object),
  needsBuildings: PropTypes.bool,
  needBuildingIds: PropTypes.arrayOf(PropTypes.string),
  needsSites: PropTypes.bool,
  needSiteIds: PropTypes.arrayOf(PropTypes.string),
  needsStates: PropTypes.bool,
  needsRegions: PropTypes.bool,
  needsCounties: PropTypes.bool,
  needsCommunities: PropTypes.bool,
  organizationId: PropTypes.string.isRequired,
  getBuildings: PropTypes.func.isRequired,
  getSites: PropTypes.func.isRequired,
  getStates: PropTypes.func.isRequired,
  getRegions: PropTypes.func.isRequired,
  getCounties: PropTypes.func.isRequired,
  getCommunities: PropTypes.func.isRequired,
  routeTo: PropTypes.func,
  openExportModal: PropTypes.func,
  showShareModal: PropTypes.func,
  showFolderInstructionsModal: PropTypes.func,
  savedProperties: PropTypes.arrayOf(PropTypes.object),
  onViewportChanged: PropTypes.func,
  // defaultZoom: PropTypes.number,
  markers: PropTypes.object,
  authenticated: PropTypes.bool,
  displayName: PropTypes.string,
};

export function mapStateToProps({
  favorites,
  areas,
  organizationId,
  modal,
  profile,
  viewer,
}) {
  const needsBuildings = favorites.folders.savedFolders.some(
    folder => (folder.buildings && folder.buildings.length > 0) &&
               favorites.items.buildings.length === 0,
  );
  const needsSites = favorites.folders.savedFolders.some(
    folder => (folder.sites && folder.sites.length > 0) &&
               favorites.items.sites.length === 0,
  );

  const activeFolderId = favorites.folders.active;
  const savedFolder = favorites.folders.savedFolders.find(sf => sf.id === activeFolderId);
  const savedBuildings = savedFolder.buildings || [];
  const savedSites = savedFolder.sites || [];
  const savedPropertiesForMap = [
    ...favorites.items.buildings
      .filter(b => savedBuildings.includes(b._id))
      .map(b => ({ ...b, propertyType: 'buildings' })),
    ...favorites.items.sites
      .filter(s => savedSites.includes(s._id))
      .map(s => ({ ...s, propertyType: 'sites' })),
  ].reduce((acc, p) => {
    if (!acc.find(a => a._id === p._id)) {
      acc.push(p);
    }
    return acc;
  }, []);

  // const zoom = parseInt(viewer.defaultZoom, 10);

  return {
    activeModal: modal,
    activeFolder: favorites.folders.active,
    folders: favorites.folders.savedFolders,
    buildings: favorites.items.buildings,
    sites: favorites.items.sites,
    states: (areas.states || []).filter(
      state => favorites.folders.savedFolders.some(
        folder => (folder.states || []).indexOf(state._id.toString()) !== -1,
      ),
    ),
    regions: (areas.regions || []).filter(
      region => favorites.folders.savedFolders.some(
        folder => (folder.regions || []).indexOf(region._id.toString()) !== -1,
      ),
    ),
    counties: (areas.counties || []).filter(
      county => favorites.folders.savedFolders.some(
        folder => (folder.counties || []).indexOf(county._id.toString()) !== -1,
      ),
    ),
    communities: (areas.communities || []).filter(
      community => favorites.folders.savedFolders.some(
        folder => (folder.communities || []).indexOf(community._id.toString()) !== -1,
      ),
    ),
    needsBuildings,
    needBuildingIds: needsBuildings
      ? favorites.folders.savedFolders.reduce((ids, folder) => [...ids, ...folder.buildings], [])
      : [],
    needsSites,
    needSiteIds: needsSites
      ? favorites.folders.savedFolders.reduce((ids, folder) => [...ids, ...folder.sites], [])
      : [],
    needsStates: favorites.folders.savedFolders.some(
      folder => (folder.states || []).length > 0 && (areas.states || []).length === 0,
    ),
    needsRegions: favorites.folders.savedFolders.some(
      folder => (folder.regions || []).length > 0 && (areas.regions || []).length === 0,
    ),
    needsCounties: favorites.folders.savedFolders.some(
      folder => (folder.counties || []).length > 0 && (areas.counties || []).length === 0,
    ),
    needsCommunities: favorites.folders.savedFolders.some(
      folder => (folder.communities || []).length > 0 && (areas.communities || []).length === 0,
    ),
    organizationId,
    authenticated: profile.authenticated,
    displayName: profile.displayName,
    savedProperties: savedPropertiesForMap,
    // defaultZoom: zoom,
    markers: viewer.markers,
  };
}

/* istanbul ignore next */
const mapDispatchToProps = dispatch => {
  return ({
    getBuildings: (org, ids) => {
      dispatch(fetchFavoriteBuildings(org, { find: JSON.stringify({ _id: ids }) }));
    },
    getSites: (org, ids) => {
      dispatch(fetchFavoriteSites(org, { find: JSON.stringify({ _id: ids }) }));
    },
    getStates: org => { dispatch(fetchAreas('states', org)); },
    getRegions: org => { dispatch(fetchAreas('regions', org)); },
    getCounties: org => { dispatch(fetchAreas('counties', org)); },
    getCommunities: org => { dispatch(fetchAreas('communities', org)); },
    routeTo: path => { dispatch(push(path)); },
    openExportModal: () => { dispatch(activateModal('export-modal')); },
    showShareModal: () => { dispatch(activateModal('share-map')); },
    showFolderInstructionsModal: () => { dispatch(activateModal('folder-instructions-modal')); },
    onViewportChanged: viewport => { dispatch(captureViewportInfo(viewport)); },
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withSize(FavoritesWrapperComponent),
);



// WEBPACK FOOTER //
// ./src/components/Favorites/FavoritesWrapper.js